import { render } from "./view.vue?vue&type=template&id=327e5094"
const script = {}

import exportComponent from "G:\\GitWorkSpace\\water\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__